import Vue from 'vue'
import Slick from 'vue-slick-carousel'

Vue.component('Slick', Slick)
